module.exports = new __parcel__URL__("pdf.worker.min.5a01939c.js").toString();